<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-background-color="backgroundColor"
  >
    <div class="logo">
      <a
        href="https://cnl.sk"
        class="simple-text logo-mini"
        target="_blank"
      >
        <div class="logo-img">
          <img :src="logo" />
        </div>
      </a>
      <a
        href="https://cnl.sk"
        class="simple-text logo-normal"
        target="_blank"
      >
        <template>{{ title }}</template>
      </a>
      <div class="navbar-minimize">
        <md-button
          id="minimizeSidebar"
          class="md-round md-just-icon md-transparent"
          @click="minimizeSidebar"
        >
          <i class="material-icons text_align-center visible-on-sidebar-regular"
            >more_vert</i
          >
          <i
            class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
            >view_list</i
          >
        </md-button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "Co to žere?",
    },
    rtlTitle: {
      type: String,
      default: "توقيت الإبداعية",
    },
    activeColor: {
      type: String,
      default: "rose",
      validator: (value) => {
        let acceptedValues = [
          "",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: "./img/logo.png",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    },
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
      };
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style scoped>

.sidebar {
  background: linear-gradient(180deg, #1a2332 0%, #242f3d 100%);
  border-right: 1px solid #374151;
  color: #f3f4f6;
}

.logo {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, rgba(16, 185, 129, 0.05) 100%);
  border-bottom: 1px solid #374151;
  padding: 16px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo a {
  color: #f3f4f6;
  text-decoration: none;
  transition: all 0.3s ease;
}

.logo a:hover {
  color: #6366f1;
}

.logo-img {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.logo-img img {
  max-width: 80px;
  height: auto;
  transform: scale(1.5);
  transform-origin: center;
}

.simple-text {
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.logo-mini {
  display: none;
}

.logo-normal {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
}

.navbar-minimize {
  position: absolute;
  top: 10px;
  right: 10px;
}

::v-deep .md-button.md-round {
  color: #d1d5db !important;
  transition: all 0.3s ease !important;
}

::v-deep .md-button.md-round:hover {
  color: #6366f1 !important;
  background: rgba(99, 102, 241, 0.15) !important;
}

.sidebar-wrapper {
  overflow-y: auto;
  max-height: calc(100vh - 140px);
  padding: 12px 0;
}

::v-deep .nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none !important;
  }
}
</style>
